import {
  Content,
  ContentHeader,

} from '@backstage/core-components';
import { useApi } from '@backstage/core-plugin-api';
import React, { useEffect, useState } from 'react';
import { Table } from '@internal/plugin-components-react';
import { Typography, Button, Box, Grid } from '@material-ui/core';
import {

  deploymentManagementApiRef,
  EnvironmentVariableRequestItems,

} from '../../api/types';
import { useParams } from 'react-router-dom';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import useAsync from 'react-use/lib/useAsync';
import useAsyncFn from 'react-use/lib/useAsyncFn';
import { EmptyTableContent } from '@internal/plugin-components-react/src/common/Table/EmptyTableContent';
import {
  AddEnvVarDialog,
  EditEnvVarDialog,
  RemoveEnvVarDialog,
} from './CustomerEnvVarDialog';

const columns = [
  {
    title: 'Service Name',
    field: 'serviceName',
    width: '20%',
    render: ({ serviceName }) => serviceName,
  },
  {
    title: 'Key',
    field: 'variableName',
    width: '20%',
    render: ({ variableName }) => variableName,
  },
  {
    title: 'Value',
    field: 'variableValue',
    width: '20%',
    render: ({ variableValue }) => variableValue,
  },
  {
    title: 'Kind',
    field: 'kind',
    width: '20%',
    render: ({ kind }) => kind,
  },
];










export const CustomerEnvVarEditPage = ({
  environmentVariables: initialEnvironmentVariables,
  onCancel,
  onSubmit,
}



) => {
  const { environmentId } = useParams();
  const deploymentManagementApi = useApi(deploymentManagementApiRef);
  const [currentEnvironmentVariables, setCurrentEnvironmentVariables] =
    useState([]);
  const [modalProps, setModalProps] = useState(null);

  const { value: masterServices } = useAsync(
    async () => deploymentManagementApi.getMasterServices(),
    [],
  );

  const [
    { loading: isUpdatingEnvironmentVariables },
    updateEnvironmentVariables,
  ] = useAsyncFn(
    async (
      ...[environmentId, updatedEnvVar]


    ) => {
      const changedEnvVar = updatedEnvVar.filter(
        variable =>
          !initialEnvironmentVariables.find(
            envVar =>
              envVar.variableName === variable.variableName &&
              envVar.variableValue === variable.variableValue,
          ),
      );
      return deploymentManagementApi.updateEnvironmentVariables(
        environmentId,
        EnvironmentVariableRequestItems.parse(changedEnvVar),
      );
    },
    [],
  );

  useEffect(() => {
    setCurrentEnvironmentVariables(
      JSON.parse(JSON.stringify(initialEnvironmentVariables)),
    );
  }, [initialEnvironmentVariables]);

  return (
    React.createElement(React.Fragment, null
      , React.createElement(Content, null
        , React.createElement(ContentHeader, {
          titleComponent: 
            React.createElement(Typography, { variant: "h5",}, "Edit Environment Variable"  )
          ,}
        
          , React.createElement(Button, {
            variant: "contained",
            color: "primary",
            onClick: () => setModalProps({ mode: 'ADD' }),}
          , "Add Variable"

          )
        )
        , React.createElement(Box, { display: "flex", justifyContent: "center",}
          , React.createElement(Box, { style: { width: '100%' },}
            , React.createElement(Table, {
              options: {
                maxBodyHeight: 'calc(100vh - 330px)',
                paging: false,
              },
              columns: [
                ...columns,
                {
                  title: 'Actions',
                  field: 'actions',
                  width: '5%',
                  render: ({ environmentVariableId }) => (
                    React.createElement(React.Fragment, null
                      , React.createElement(EditIcon, {
                        color: "primary",
                        style: { cursor: 'pointer' },
                        onClick: () =>
                          setModalProps({
                            mode: 'EDIT',
                            environmentVariableId,
                          })
                        ,}
                      )
                      , false && (
                        React.createElement(DeleteIcon, {
                          color: "primary",
                          style: { cursor: 'pointer' },
                          onClick: () =>
                            setModalProps({
                              mode: 'REMOVE',
                              environmentVariableId,
                            })
                          ,}
                        )
                      )
                    )
                  ),
                },
              ],
              data: currentEnvironmentVariables || [],
              emptyContent: 
                React.createElement(EmptyTableContent, null
                  , environmentId === null
                    ? 'Please select one customer environment first'
                    : currentEnvironmentVariables?.length === 0
                    ? "There's no environment variable yet"
                    : null
                )
              ,}
            )
            , React.createElement(Grid, {
              container: true,
              spacing: 2,
              direction: "column",
              alignItems: "flex-end",}
            
              , React.createElement(Grid, { item: true, style: { margin: '15px 8px' },}
                , React.createElement(Button, { variant: "outlined", color: "primary", onClick: onCancel,}, "Back"

                )
                , React.createElement(Button, {
                  variant: "contained",
                  color: "primary",
                  style: { marginLeft: '15px' },
                  onClick: async () => {
                    await updateEnvironmentVariables(
                      environmentId,
                      currentEnvironmentVariables,
                    );
                    onSubmit();
                  },
                  disabled: 
                    isUpdatingEnvironmentVariables ||
                    JSON.stringify(currentEnvironmentVariables) ===
                      JSON.stringify(initialEnvironmentVariables)
                  ,}
                , "Save"

                )
              )
            )
          )
        )
      )
      , modalProps?.mode === 'ADD' && (
        React.createElement(AddEnvVarDialog, {
          environmentVariables: currentEnvironmentVariables,
          serviceNames: 
            masterServices?.map(({ serviceName }) => serviceName) || []
          ,
          onSubmit: environmentVariables => {
            setCurrentEnvironmentVariables(environmentVariables);
            setModalProps(null);
          },
          onCancel: () => setModalProps(null),}
        )
      )
      , modalProps?.mode === 'EDIT' && (
        React.createElement(EditEnvVarDialog, {
          environmentVariables: currentEnvironmentVariables,
          environmentVariableId: modalProps.environmentVariableId,
          onSubmit: environmentVariables => {
            setCurrentEnvironmentVariables(environmentVariables);
            setModalProps(null);
          },
          onCancel: () => setModalProps(null),}
        )
      )
      , modalProps?.mode === 'REMOVE' && (
        React.createElement(RemoveEnvVarDialog, {
          environmentVariables: currentEnvironmentVariables,
          environmentVariableId: modalProps.environmentVariableId,
          onSubmit: environmentVariables => {
            setCurrentEnvironmentVariables(environmentVariables);
            setModalProps(null);
          },
          onCancel: () => setModalProps(null),}
        )
      )
    )
  );
};
